<iframe
    [width]="data.width"
    [height]="data.width"
    frameborder="0"
    style="border:0"
    [src]="data.url | secureUrl"
>
</iframe>
